import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { CoverageSVG, ExpirySVG } from '../../img/GlobalSVG';
import Button from '../common/button';
import GenericButton from '../../../Components/GenericButton/GenericButton';

const RegistrationErrorMsg = ({
  errorContent = 'The registration link you have clicked on has expired. It seems like this page is no longer available.',
}) => {
  return (
    <Container className="registration-error-container text-center mt-5">
      <Row>
        <Col>
          <ExpirySVG.ExpirySVG />
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="content-box">
            <div className="registration-error-title">{errorContent}</div>
            <p>Please contact the administrator</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="did-you-know-container-box d-flex">
            <CoverageSVG.BulbSVG />
            <div className="content-box text-left">
              <h4>Did you know?</h4>
              <p>
                If you are physically tired, the best thing to do is exercise as
                it will give you more energy than sitting.
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default RegistrationErrorMsg;
